import {
  Box,
  Container,
  ContainerOwnProps,
  SxProps,
  Theme,
} from "@mui/material";
import { Outlet } from "react-router-dom";

export function PageLayout({
  maxWidth = "lg",
}: {
  maxWidth?: ContainerOwnProps["maxWidth"] | false;
}) {
  return (
    <Container sx={{ pt: 3 }} maxWidth={maxWidth}>
      <Outlet />
    </Container>
  );
}

export function InventoryPageHeader({
  children,
  sx,
  disableYPadding = false,
}: {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  disableYPadding?: boolean;
}) {
  return (
    <Box
      width="100%"
      maxWidth={1235}
      sx={{
        display: "block",
        mx: "auto",
        p: 5,
        pt: 1,
        ...(disableYPadding && { py: 0 }),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
